import { PartnerPending } from "../entities/partnerPending";
import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";

export class GetPendingPartners {
	constructor(private repository: PartnerSocketRepository) {}
	execute(): Promise<PartnerPending[]> {
		return this.repository.getPendingPartners();
	}
}
